export default "__VITE_ASSET__CGu2pHoe__"